/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../../components";
import { GetAllPromotionalNotificationList } from "../../../utilities/api/promotional-notification";
import { toast } from "react-toastify";
import { LableFromEnums } from "../../../utilities";
import { useAppSelector } from "../../../redux/Hooks/Hook";

const ListOfPromotioanlNotification = () => {
  const navigate = useNavigate();
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const [data, setData] = useState([]) as any;

  useEffect(() => {
    GetAllPromotionalNotificationList()
      .then((res) => {
        const updatedRows = res?.data?.rows?.map((_val: any, _index: any) => ({
          SrNo: _index + 1,
          name: _val?.title,
          notificationType: _val?.templateName,
          createdAt: _val?.createdAt,
          startDate: _val?.startDate,
          endDate: _val?.endDate,
          sendTo: _val?.sendToUsers?.map((item: any) => LableFromEnums(item, Enums)).join(", "),
          event: _val?.sendOnDays?.join(", "),
          status: _val?.isActive ? "Active" : "Inactive",
          ...(_val || {}),
        }));
        setData(updatedRows || []);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "SrNo",
      },
      {
        Header: "Notification Name",
        accessor: "notificationType",
      },
      {
        Header: "Notification Title",
        accessor: "name",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
      },
      {
        Header: "Start Date",
        accessor: "startDate",
      },
      {
        Header: "End Date",
        accessor: "endDate",
      },
      {
        Header: "Sending to",
        accessor: "sendTo",
      },
      {
        Header: "Sending Event",
        accessor: "event",
      },
    ],
    []
  );
  const handleAdd = () => {
    navigate("/add-promotional-notification", {
      state: { for: "Create" },
    });
  };

  const handleEdit = (id: string) => {
    navigate(`/promotional-notification/${id}`, {
      state: { id: id, for: "Update" },
    });
  };



  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">
              Promotional Notification List
            </Card.Title>
            <ButtonGroup>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Create New"
                name="add-notification"
                id="add-notification"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table
          columns={columns}
          data={data}
          handleEdit={handleEdit}
          hideViewAction={true}
          hideDeleteAction={true}
        />
      </Card>
    </>
  );
};

export { ListOfPromotioanlNotification };
